
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getOptions } from '../../../MyApi/product/options';
import LoadingSpinner from '../../UI/spinner';
import OptionsModal from './optionsmodal';

const ProductOptions = ({ productOptions, setProductOptions }) => {
    const { data, isLoading ,refetch } = useQuery("getOptions", getOptions);
    const [isModalOpen ,setIsModalOpen]=useState(false)
    const options = data?.data.options || [];
    const {t}=useTranslation()
    const handleOptionChange = (index, field, value) => {
        const updatedOptions = [...productOptions];
        updatedOptions[index][field] = value;
        setProductOptions(updatedOptions);
    };

    const handleValueChange = (optionIndex, valueIndex, field, value) => {
        const updatedOptions = [...productOptions];
        updatedOptions[optionIndex].values[valueIndex][field] = value;
        setProductOptions(updatedOptions);
    };

    const addOption = () => {
        setProductOptions([
            ...productOptions,
            {          
                option_id: "",
                min_select: 1,
                max_select: 1,
                is_required: 1,
                sort_order: productOptions.length + 1,
                values: [
                    {
                        name: "",
                        price: "",
                        stock: "",
                        is_default: 1
                    }
                ]
            }
        ]);
    };

    const removeOption = (index) => {
        const updatedOptions = productOptions.filter((_, i) => i !== index);
        setProductOptions(updatedOptions);
    };

    const addValue = (optionIndex) => {
        const updatedOptions = [...productOptions];
        updatedOptions[optionIndex].values.push({
            name: "",
            price: "",
            stock: "",
            is_default: 0
        });
        setProductOptions(updatedOptions);
    };

    const removeValue = (optionIndex, valueIndex) => {
        const updatedOptions = [...productOptions];
        updatedOptions[optionIndex].values = updatedOptions[optionIndex].values.filter(
            (_, i) => i !== valueIndex
        );
        setProductOptions(updatedOptions);
    };

    const openModal =()=>{
        setIsModalOpen(true)
    }
    const closeModal =()=>{
        setIsModalOpen(false)
    }

    if (isLoading) {
        return (
            <div className="product-options table">
                <h4> إضافة مجموعة اختيارات المنتج</h4>
                <LoadingSpinner/>
            </div>
        );
    }

    return (
        <div className="product-options">   
            <div className='d-flex justify-content-between mb-3'>
            <h5>  مجموعة اختيارات المنتج</h5>
            <button className='btn btn-primary'  type='button' onClick={openModal}>إضافة خيارات منتج</button>
            </div>
<OptionsModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} closeModal={closeModal} refetch={refetch}/>
            
      
            {productOptions.map((option, optionIndex) => (
                <div key={optionIndex} className="option-group mb-4 p-3 border rounded">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5>خيار #{optionIndex + 1}</h5>
                        {productOptions.length > 1 && (   
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeOption(optionIndex)}
                            >
                                حذف الخيار
                            </button>
                        )}
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label className="form-label">اختر الخيار *</label>
                                <select
                                    value={option.option_id}
                                    onChange={(e) => handleOptionChange(optionIndex, 'option_id', e.target.value)}
                                    className="form-select"
                                    
                                >
                                    <option value="">اختر الخيار من القائمة</option>
                                    {options.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {t(opt.name)} 
                                        </option>
                                    ))}
                                </select>
                                {/* <small className="text-muted">
                                    اختر الخيار المناسب من الخيارات المتاحة في النظام
                                </small> */}
                            </div>
                        </div>
                        
                        {/* <div className="col-md-3">
                            <div className="form-group mb-3"> */}
                                {/* <label className="form-label">الحد الأدنى للاختيار</label> */}
                                {/* <input
                                    type="number"
                                    value={option.min_select}
                                    onChange={(e) => handleOptionChange(optionIndex, 'min_select', parseInt(e.target.value) || 0)}
                                    className="form-control"
                                    min="0"
                                    hidden
                                /> */}
                                {/* <small className="text-muted">أقل عدد يمكن اختياره</small> */}
                            {/* </div>
                        </div> */}
                        
                        {/* <div className="col-md-6">
                            <div className="form-group mb-3"> */}
                                {/* <label className="form-label">الحد الأقصى للاختيار</label> */}
                                {/* <input
                                    type="number"
                                    value={option.max_select}
                                    onChange={(e) => handleOptionChange(optionIndex, 'max_select', parseInt(e.target.value) || 1)}
                                    className="form-control"
                                    min="1"
                                    hidden
                                /> */}
                                {/* <small className="text-muted">أكثر عدد يمكن اختياره</small> */}
                            {/* </div>
                        </div> */}
                        
                        {/* <div className="col-md-4">
                            <div className="form-check mb-3"> */}
                                {/* <input
                                    type="checkbox"
                                    checked={option.is_required === 1}
                                    onChange={(e) => handleOptionChange(optionIndex, 'is_required', e.target.checked ? 1 : 0)}
                                    className="form-check-input"
                                    id={`required-${optionIndex}`}
                                /> */}
                                {/* <label className="form-check-label" htmlFor={`required-${optionIndex}`}>
                                    مطلوب
                                </label>
                                <small className="text-muted d-block">يجب على العميل اختيار هذا الخيار</small> */}
                            {/* </div>
                        </div> */}
                        
                        <div className="col-md-4">
                            <div className="form-group mb-3">
                                <label className="form-label">ترتيب العرض</label>
                                <input
                                    type="number"
                                    value={option.sort_order}
                                    onChange={(e) => handleOptionChange(optionIndex, 'sort_order', parseInt(e.target.value) || 1)}
                                    className="form-control"
                                    min="1"
                                />
                                <small className="text-muted">رقم يعبر عن ترتيب ظهور الخيار</small>
                            </div>
                        </div>

                      
                   
                    </div>
                    
                    <h6 className="mt-3">قيم الخيار:</h6>
                    {option.values.map((value, valueIndex) => (
                        <div key={valueIndex} className="value-group mb-3 p-2 border rounded">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group mb-2">
                                        <label className="form-label">اسم القيمة *</label>
                                        <input
                                            type="text"
                                            value={value.name}
                                            onChange={(e) => handleValueChange(optionIndex, valueIndex, 'name', e.target.value)}
                                            className="form-control"
                                            placeholder="مثال: أحمر، كبير، إلخ"
                                            
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-2">
                                    <div className="form-group mb-2">
                                        <label className="form-label">السعر الإضافي</label>
                                        <input
                                            type="number"
                                            value={value.price}
                                            onChange={(e) => handleValueChange(optionIndex, valueIndex, 'price', e.target.value)}
                                            className="form-control"
                                            placeholder="0"
                                            step="0.01"
                                            min="0"
                                        />
                                        <small className="text-muted">السعر الإضافي لهذه القيمة</small>
                                    </div>
                                </div>
                                
                                <div className="col-md-2">
                                    <div className="form-group mb-2">
                                        <label className="form-label">المخزون</label>
                                        <input
                                            type="number"
                                            value={value.stock}
                                            onChange={(e) => handleValueChange(optionIndex, valueIndex, 'stock', parseInt(e.target.value) || 0)}
                                            className="form-control"
                                            placeholder="0"
                                            min="0"
                                        />
                                        <small className="text-muted">الكمية المتاحة</small>
                                    </div>
                                </div>
                                
                                {/* <div className="col-md-3">
                                    <div className="form-check mb-2">
                                        <input
                                            type="checkbox"
                                            checked={value.is_default === 1}
                                            onChange={(e) => handleValueChange(optionIndex, valueIndex, 'is_default', e.target.checked ? 1 : 0)}
                                            className="form-check-input"
                                            id={`default-${optionIndex}-${valueIndex}`}
                                        />
                                        <label className="form-check-label" htmlFor={`default-${optionIndex}-${valueIndex}`}>
                                            افتراضي
                                        </label>
                                        <small className="text-muted d-block">سيتم اختياره تلقائياً</small>
                                    </div>
                                </div> */}
                                
                                <div className="col-md-2">
                                    {option.values.length > 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger mt-4"
                                            onClick={() => removeValue(optionIndex, valueIndex)}
                                        >
                                            حذف
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                    
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => addValue(optionIndex)}
                    >
                        + إضافة قيمة جديدة
                    </button>
                </div>
            ))}
            
            <div className="d-flex gap-2">
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={addOption}
                >
                    + إضافة خيار جديد
                </button>
                
       
            </div>

   
        </div>
    );
};

export default ProductOptions;